import React from "react";

function getYouTubeId(url) {
    if (!url) return "";
    if (url.includes("/embed/")) {
        const m = url.match(/\/embed\/([\w-]{11})/);
        return m ? m[1] : "";
    }
    const m = url.match(/(?:v=|youtu\.be\/|shorts\/)([\w-]{11})/);
    return m ? m[1] : "";
}

function getYouTubeEmbed(url) {
    const id = getYouTubeId(url);
    if (!id) return url;
    return `https://www.youtube.com/embed/${id}?autoplay=0&controls=1&rel=0&modestbranding=1`;
}

/**
 * Inline player (used elsewhere or fallback) — original behaviour.
 */
export default function VideoPlayer({ type, url, poster }) {
    if (type === "none" || !url) {
        return (
            <div className="aspect-video w-full rounded-xl bg-ink-800 border border-white/5 overflow-hidden relative">
                {poster ? <img src={poster} alt="Hero" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-ink-800 to-ink-900" />}
                <div className="absolute inset-0 bg-black/40" />
            </div>
        );
    }
    if (type === "youtube") {
        return (
            <div className="aspect-video w-full rounded-xl overflow-hidden border border-white/10 bg-black">
                <iframe data-testid="hero-youtube-frame" src={getYouTubeEmbed(url)} title="Showreel" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" referrerPolicy="strict-origin-when-cross-origin" />
            </div>
        );
    }
    return (
        <div className="aspect-video w-full rounded-xl overflow-hidden border border-white/10 bg-black">
            <video data-testid="hero-video-file" src={url} poster={poster || undefined} controls playsInline className="w-full h-full object-cover" />
        </div>
    );
}

/**
 * BackgroundVideo — covers parent container, muted+looped autoplay.
 * Used as hero background.
 */
export function BackgroundVideo({ type, url, poster }) {
    if (type === "none" || !url) {
        return (
            <div className="absolute inset-0 w-full h-full overflow-hidden bg-ink-900">
                {poster && <img src={poster} alt="" className="w-full h-full object-cover opacity-60" />}
            </div>
        );
    }

    if (type === "youtube") {
        const id = getYouTubeId(url);
        if (!id) return null;
        const src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1&iv_load_policy=3&disablekb=1`;
        return (
            <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
                <iframe
                    data-testid="hero-bg-youtube"
                    src={src}
                    title="Hero background"
                    allow="autoplay; encrypted-media"
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] h-[56.25vw] min-w-full min-h-full"
                    frameBorder="0"
                    referrerPolicy="strict-origin-when-cross-origin"
                />
            </div>
        );
    }

    // direct file mp4
    return (
        <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
            <video
                data-testid="hero-bg-video"
                src={url}
                poster={poster || undefined}
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                controls={false}
                className="absolute inset-0 w-full h-full object-cover"
            />
        </div>
    );
}
